(function () {
  if (customElements.get('ce-quick-view') !== undefined) {
    return;
  }

  class QuickView extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        buttonOpen: '[data-quick-view-button-open]',
        modal: '[data-quick-view-modal]',
        buttonClose: '[data-quick-view-button-close]',
        content: '[data-quick-view-content]',
      };

      this.isLoaded = false;

      this._handleClick = this._handleClick.bind(this);
    }

    parsedCallback() {
      this.elements = {
        buttonOpen: this.querySelector(this.selectors.buttonOpen),
        modal: this.querySelector(this.selectors.modal),
        buttonClose: this.querySelector(this.selectors.buttonClose),
        content: this.querySelector(this.selectors.content),
      };

      this.elements.buttonOpen.addEventListener('click', this._handleClick);
    }

    disconnectedCallback() {
      this.elements.buttonOpen.removeEventListener('click', this._handleClick);
    }

    _handleClick() {
      if (!this.isLoaded) {
        this._fetchSection();
      }
    }

    async _fetchSection() {
      const resource = this.elements.buttonOpen.dataset.url;

      try {
        const response = await fetch(resource);

        if (!response.ok) {
          throw Error;
        }

        const responseBody = await response.text();

        let html = new DOMParser().parseFromString(responseBody, 'text/html');
        html = html.querySelector('[id$="__main_product"]');
        html.querySelector('ce-product').removeAttribute('main');
        html.querySelector('[data-quick-view-container]').classList.remove('top-padding-none', 'top-padding-small', 'top-padding-medium', 'top-padding-large', 'bottom-padding-none', 'bottom-padding-small', 'bottom-padding-medium', 'bottom-padding-large');
        html.querySelector('[data-quick-view-container]').classList.add('py-4', 'md:py-6');

        const markupToRemove = [...html.querySelectorAll('[data-quick-view-markup-to-remove]')];
        for (let m of markupToRemove) {
          m.remove();
        }

        const nodeTax = html.querySelector('[data-quick-view-template-tax]')?.content.cloneNode(true);
        html.querySelector('[data-quick-view-target-tax]')?.appendChild(nodeTax);

        const nodePickupAvailability = html.querySelector('[data-quick-view-template-pickup-availability]')?.content.cloneNode(true);
        html.querySelector('[data-quick-view-target-pickup-availability]')?.appendChild(nodePickupAvailability);

        const nodeSubscriptionPolicy = html.querySelector('[data-quick-view-template-subscription-policy]')?.content.cloneNode(true);
        html.querySelector('[data-quick-view-target-subscription-policy]')?.appendChild(nodeSubscriptionPolicy);

        const nodeViewDetails = html.querySelector('[data-quick-view-template-view-details]')?.content.cloneNode(true);
        html.querySelector('[data-quick-view-target-view-details]')?.appendChild(nodeViewDetails);

        this.elements.content.innerHTML = html.innerHTML;

        if (!Shopify.designMode) {
          trapFocus(this.elements.modal, { elementToFocus: this.elements.buttonClose });
        }

        this.isLoaded = true;
      } catch (error) {
        // Fail silently.
      }
    }
  }

  customElements.define('ce-quick-view', QuickView);
})();
